(() => {
  if (window.__o2AcceleratedCheckoutInit) return;
  window.__o2AcceleratedCheckoutInit = true;

  const wrapperSelector = '.cart-accelerated-checkout-o2';
  const dynamicButtonsSelector = '.cart__dynamic-checkout-buttons';
  const allowedInputSelector = 'input[name="attributes[expressCheckoutAllowed]"]';
  const quantityInputSelector = 'input[name="updates[]"]';
  const stateByWrapper = new WeakMap();
  let currentAllowedValue = 'false';
  let lastAllowedValue = null;
  let allowedSyncPromise = Promise.resolve();

  const syncAllowedAttribute = (input) => {
    const value = input.value === 'true' ? 'true' : 'false';
    if (lastAllowedValue === value) return allowedSyncPromise;
    if (lastAllowedValue === null && input.dataset.storedValue === value) {
      lastAllowedValue = value;
      return Promise.resolve();
    }

    lastAllowedValue = value;
    allowedSyncPromise = window.O2CartAttributes.update({ expressCheckoutAllowed: value }).catch((error) => {
      if (lastAllowedValue === value) lastAllowedValue = null;
      console.error('[accelerated-checkout-attributes-o2] Unable to persist express eligibility.', error);
    });
    return allowedSyncPromise;
  };

  if (!customElements.get('cart-express-checkout-attribute-o2')) {
    customElements.define(
      'cart-express-checkout-attribute-o2',
      class extends HTMLElement {
        connectedCallback() {
          const input = this.querySelector(allowedInputSelector);
          if (!input?.form) return;
          const hasPendingQuantity = [...document.querySelectorAll(quantityInputSelector)].some(
            (quantity) => quantity.value !== quantity.defaultValue
          );
          input.value = input.dataset.allowedValue === 'true' && !hasPendingQuantity ? 'true' : 'false';
          // Other native forms may still submit quantities from their previous section render.
          currentAllowedValue = input.value;
          syncAllowedAttribute(input);
        }
      }
    );
  }

  const invalidateEligibility = () => {
    const input = document.querySelector(allowedInputSelector);
    if (!input) return;
    currentAllowedValue = 'false';
    document.querySelectorAll(allowedInputSelector).forEach((peer) => (peer.value = 'false'));
    syncAllowedAttribute(input);
  };

  const handleQuantityEdit = (event) => {
    if (event.target instanceof HTMLInputElement && event.target.matches(quantityInputSelector)) {
      invalidateEligibility();
    }
  };

  document.addEventListener('input', handleQuantityEdit, true);
  document.addEventListener('change', handleQuantityEdit, true);
  document.addEventListener(
    'click',
    (event) => {
      if (event.target instanceof Element && event.target.closest('cart-remove-button')) invalidateEligibility();
    },
    true
  );

  const getWrapper = (target) => {
    if (!(target instanceof Element)) return null;
    return target.closest(wrapperSelector);
  };

  // Wallets use the current server cart rather than submitting a native form's updates[].
  const getAttributes = () => ({
    expressCheckout: 'true',
    expressCheckoutAllowed: currentAllowedValue,
  });

  const ensureAttributesSynced = (wrapper) => {
    if (!wrapper) return Promise.resolve();

    const attributes = getAttributes();
    const existingState = stateByWrapper.get(wrapper);
    if (existingState?.done && existingState.allowed === attributes.expressCheckoutAllowed) return Promise.resolve();
    if (existingState?.promise && existingState.allowed === attributes.expressCheckoutAllowed)
      return existingState.promise;

    lastAllowedValue = attributes.expressCheckoutAllowed;
    const promise = window.O2CartAttributes.update(attributes, { immediate: true, keepalive: true })
      .then(() => {
        if (stateByWrapper.get(wrapper)?.promise === promise) {
          stateByWrapper.set(wrapper, { done: true, promise: null, allowed: attributes.expressCheckoutAllowed });
        }
      })
      .catch(() => {
        if (lastAllowedValue === attributes.expressCheckoutAllowed) lastAllowedValue = null;
        if (stateByWrapper.get(wrapper)?.promise === promise)
          stateByWrapper.set(wrapper, { done: false, promise: null });
      });

    allowedSyncPromise = promise;
    stateByWrapper.set(wrapper, { done: false, promise, allowed: attributes.expressCheckoutAllowed });

    return promise;
  };

  const shouldHandleKeyboardEvent = (event) => event.key === 'Enter' || event.key === ' ';

  const handleIntent = (event) => {
    if (event.type === 'keydown' && !shouldHandleKeyboardEvent(event)) return;

    const wrapper = getWrapper(event.target);
    if (!wrapper) return;

    const dynamicButtons = wrapper.querySelector(dynamicButtonsSelector);
    if (!dynamicButtons || !dynamicButtons.contains(event.target)) return;

    ensureAttributesSynced(wrapper);
  };

  document.addEventListener('pointerdown', handleIntent, true);
  document.addEventListener('click', handleIntent, true);
  document.addEventListener('keydown', handleIntent, true);
})();
